import { Tooltip } from '@mui/material';
import { omit } from 'lodash';
import { useCallback } from 'react';
import {
  StyledBaseTooltipWrapper,
  StyledTooltipWrapper,
} from 'src/components/tooltip/CustomTooltip.styled';

import { getTooltipStyles } from './CustomTooltip.helper';
import { useCustomTooltip } from './CustomTooltip.hook';
import { CustomTooltipProps } from './CustomTooltip.interface';

export const CustomTooltip = (props: CustomTooltipProps) => {
  const {
    title,
    isSecondaryTooltip,
    isHidden,
    width,
    fontSize,
    overflowWidth,
    overflowLineNumber,
    cursor = 'default',
    skipValidateOverflow = false,
    placement,
    children,
    renderChildren,
  } = props;

  const { overflow, childrenElement } = useCustomTooltip({
    title,
    overflowWidth,
    overflowLineNumber,
    skipValidateOverflow,
    children,
    renderChildren,
  });

  const renderStyledTooltipWrapper = useCallback(() => {
    const WrapperComponent = renderChildren
      ? StyledBaseTooltipWrapper
      : StyledTooltipWrapper;

    return (
      <WrapperComponent
        $overflow={overflow}
        $overflowWidth={overflowWidth}
        $overflowLineNumber={overflowLineNumber}
        $cursor={cursor}>
        {childrenElement}
      </WrapperComponent>
    );
  }, [
    renderChildren,
    overflow,
    overflowWidth,
    overflowLineNumber,
    cursor,
    childrenElement,
  ]);

  const isTooltipEnabled =
    !!title && !isHidden && (overflow || skipValidateOverflow);

  return isTooltipEnabled ? (
    <Tooltip
      placement={placement || 'right'}
      arrow
      slotProps={getTooltipStyles({
        isSecondaryTooltip,
        isHidden,
        width,
        fontSize,
      })}
      {...omit(props, [
        'isSecondaryTooltip',
        'isHidden',
        'width',
        'fontSize',
        'overflowWidth',
        'overflowLineNumber',
        'skipValidateOverflow',
        'placement',
        'arrow',
        'slotProps',
        'componentsProps',
        'renderChildren',
      ])}>
      <div>{renderStyledTooltipWrapper()}</div>
    </Tooltip>
  ) : (
    renderStyledTooltipWrapper()
  );
};
